import { useState } from 'react'
import { api } from '../lib/api.ts'
import { BrandMark } from './BrandMark.tsx'

export function LoginGate({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [busy, setBusy] = useState(false)
  const [reveal, setReveal] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!password || busy) return
    setBusy(true)
    setError(false)
    try {
      if (await api.login(password)) onSuccess()
      else setError(true)
    } catch {
      setError(true)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="gate">
      <form className="gate__card" onSubmit={submit}>
        <BrandMark />
        <h1 className="gate__title">Virtual Central Office</h1>
        <p className="gate__lead">Enter the access password to continue.</p>
        <div className="field">
          <label className="field__label" htmlFor="access-password">
            Access password
          </label>
          <div className="field__control">
            <input
              id="access-password"
              type={reveal ? 'text' : 'password'}
              className="input input--peek"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value)
                setError(false)
              }}
              autoComplete="current-password"
              placeholder="••••••••••••"
            />
            <button
              type="button"
              className="peek"
              onClick={() => setReveal((v) => !v)}
              aria-label={reveal ? 'Hide password' : 'Show password'}
              aria-pressed={reveal}
            >
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M2.2 12S6 5.8 12 5.8 21.8 12 21.8 12 18 18.2 12 18.2 2.2 12 2.2 12Z" />
                <circle cx="12" cy="12" r="2.6" />
                {reveal && <line x1="4" y1="20" x2="20" y2="4" />}
              </svg>
            </button>
          </div>
        </div>
        {error && <p className="notice notice--error">Incorrect password.</p>}
        <button className="btn btn--primary btn--block" type="submit" disabled={busy || !password}>
          {busy ? 'Checking…' : 'Enter'}
        </button>
      </form>
    </div>
  )
}
